export const DEG = Math.PI / 180;
export const RAD = 180 / Math.PI;
